<template>
  <div class="course-detail-wrapper">
    <div class="course-detail">
      <div class="detail-nav">
        当前位置：首页>课程中心>{{ detail.title }}
      </div>
      <div class="detail-top">
        <img v-if="!isShow" :src="detail.imageUrl" class="goods-img"/>
        <div class="aliplayer goods-img" v-if="isShow">
          <vue-aliplayer-v2
              ref="VueAliplayerV2"
              :source="source"
              :options="options"
          />
        </div>
        <div class="detail-list">
          <div class="detail-list-top">
            <span>课程列表</span>
            <span class="title-btn1">
              <em :class=" { collection: detail.collection === 1 }" @click="handleClickCollection(detail)">
              {{ detail.collection === 1 ? "已收藏" : "未收藏" }}</em>
            </span>
            <span class="title-btn2" @mouseenter="showSharePopup=true" @mouseleave="showSharePopup=false">
              <em :class=" { collection: showSharePopup }" >分享</em>
              <!-- 分享弹出层 -->

              <div v-if="showSharePopup" class="share-popup">
                <share :config="config"></share>
              </div>
            </span>
          </div>
          <div class="detail-list-content">
            <a-collapse :bordered="false" :activeKey="activeKeys">
              <template #expandIcon="props">
                <a-icon type="plus-circle" theme="filled" v-if="!props.isActive"/>
                <a-icon type="minus-circle" theme="filled" v-else/>
              </template>
              <a-collapse-panel
                  :header="panel.title"
                  v-for="(panel, i) in detail.courseChapterVos"
                  :key="i"
              >
                <div
                    class="course-item"
                    v-for="item in panel.courseChapterVideoVos"
                    :key="item.id"
                    @click="handleVideoPlayer(item)"
                >
                  <h5>{{ item.title }}</h5>
                  <p>{{ setTime(item.duration, true) }}</p>
                  <!--                <img src="@/assets/img/lock.png" />-->
                  <img v-if="item.id==cid" src="@/assets/img/play-icon.png"/>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </div>
      </div>
      <div class="detail-info">
        <div class="detail-list">
          <div class="detail">
            <div class="category-info">
              <span
                  :style="'padding:3px 10px;color:#ffffff;height:24px;border-radius: 3px;background:'+detail.plateColor"
                  v-if="detail.plateName">{{ detail.plateName }}</span>
              {{ detail.categoryName }}
            </div>
            <h4 class="title">{{ detail.title }}</h4>
            <div class="price">
              <span v-if="detail.price>0">价格:<em>￥</em><strong>{{ detail.price }}</strong></span>
              <span v-else><font class="free">免费</font></span>
              <span>总章:<strong></strong>
              {{ detail.courseChapterVos != null && detail.courseChapterVos.length }}节
            </span>
              <span>总时长:{{ setTime(detail.courseTime) }}</span>
            </div>
            <div class="lecturer">
              讲师:<strong v-for="(item,index) of detail.teacherVos" :key="index">
              {{ item.fullName }}
            </strong>
            </div>
          </div>
          <div>
            <div class="btn" v-if="+detail.isBuy === 0">
              <span v-if="detail.price>0" @click="handleBuy(detail)">立即购买</span>
              <span v-else-if="isLogin" @click="handleStartPlayer(detail)">免费播放</span>
              <span v-else @click="$router.push({ name: 'Login' })">会员免费</span>
            </div>
            <!--          <div class="btn" v-if="+detail.isBuy === 0 && detail.price>0" @click="handleBuy(detail)">立即购买</div>-->
            <div class="btn" v-if="+detail.isBuy === 1" @click="handleStartPlayer(detail)">立即播放</div>
          </div>
        </div>

      </div>
    </div>
    <div class="course-introduction">
      <h3 class="title">简介
        <!--        <img src="~@/assets/img/courseContent.png" width="53"/>-->
      </h3>

      <div class="course-teacher-info">
        <div class="course-teacher-title">
          <div class="name">老师简介</div>
          <div class="content">课程大纲</div>
        </div>
        <div class="course-teacher-content">
          <div class="teacher"><span v-for="(item,index) of detail.teacherVos" :key="index">{{ item.fullName }}</span>
          </div>
          <div class="content"><span></span>{{ detail.content }}</div>
        </div>
      </div>
      <div class="course-image" v-if="detail.image"><img :src="detail.image" /></div>
    </div>
    <div class="course-need">
      <span class="title">使用须知</span>
      <div v-for="(li,index) of instructionsData" :key="index">
        <div class="list-title"><span>{{ index + 1 }}</span> {{ li.title }}</div>
        <div class="list-content">{{ li.content }}</div>
        <div class="list-line"></div>
      </div>
    </div>
    <!--    用户评价信息-->
    <div class="course-msg" v-if="msgReplyData!=null&&msgReplyData.length>0">
      <div class="msg-video-reply">
        <div>
          用户评价
        </div>
        <div v-for="item in msgReplyData" :key="item.id">
          <div class="video-item">
            <div class="video-bbs">
              <div class="userAvatar">
                <img :src="item.avatar" :class="{ 'img-sub': !styleFlag }"/>
                <span>{{ item.nickname }}</span>
                <em v-for="(wjx,index) of item.courseScore" :key="index" class="collection"></em>
                <em v-for="(wjx,index) of (5-item.courseScore)" :key="index"></em>
              </div>
              <div class="desc">
                <em v-if="styleFlag">{{ item.userTag ? item.userTag : "未知" }}</em
                >{{ item.comment }}{{ item.comment }}{{ item.comment }}{{ item.comment }}{{
                  item.comment
                }}{{ item.comment }}{{ item.comment }}
              </div>
              <div class="footer clearfix">
                <div class="good-wrap" :class="{ sub: !styleFlag }">
                  <span>{{ item.createTime }}</span>
<!--                  <img src="@/assets/img/user/good.png" class="good"/>-->

                  <!--                  点赞({{item.likeCount}})-->
                  <!--                  <img src="@/assets/img/user/msg.png" style="opacity: 0.4" class="good" />-->
                  <!--                  <span v-if="styleFlag">评论({{ item.content }})</span>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {artCourseDetail, collectAdd, getInstructions, getReplyList, getPlayAuth} from "@/api/CourseCenter";
import {mapGetters} from "vuex";

export default {
  name: "CourseDetail",
  components: {},
  data() {
    return {
      config: {
        // url: "", // 网址，默认使用 window.location.href
        source: "", // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
        title: "", // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
        description: "", // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
        image: "", // 图片, 默认取网页中第一个img标签
        sites: [
          "qq","weibo", "wechat",
        ], // 启用的站点
        // disabled: ["google", "facebook", "twitter"], // 禁用的站点
        wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
        wechatQrcodeHelper:"<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
      },
      options: {
        // isLive: true, //切换为直播流的时候必填
        // format: 'm3u8'  //切换为直播流的时候必填
        enableSystemMenu: false,//是否允许系统右键菜单显示，默认为 false。
        width: "100%",
        height: "100%",
        autoplay: false,
        cover: '',

        vid: "bf9df3e2c915400e8517ef0e584a340f",
        license: {domain: "ykmeik.com", key: "tPno6NEBngJXgBuPOf6f35a710540471587ac360e1e79b558"},
        playauth: "",
      },
      source: "",
      isShow: false,
      id: null,
      cid: 0,//这个是视频
      showSharePopup: false,
      instructionsData: [],
      msgReplyData: [],
      detail: {},
      styleFlag: false,
      activeKeys: [] // 默认展开的面板的 key 数组
    };
  },
  computed: mapGetters(["userInfo", "isLogin"]),
  mounted() {
    // 禁用右键菜单
    document.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });

    // 禁用开发者工具
    document.addEventListener("keydown", (e) => {
      if (e.key === "F12" || (e.ctrlKey && e.shiftKey && e.key === "I")) {
        e.preventDefault();
      }
    });
    this.id = this.$route.params.id;
    console.log("$route", this.id);
    this.artCourseDetailFunc();
  },

  methods: {
    setHeight() {
      let ele = document.querySelector(".aliplayer");
      let W = ele.clientWidth;
      console.log("playerHeight", W);
      let H = parseInt((664 * W) / 1220) + "px";
      ele.style.height = H;
    },
    handleClickCollection(detail) {
      /**collectAdd 接口添加收藏、取消收藏共用一个接口*/
      collectAdd({courseId: detail.id, category: "collect"})
          .then((res) => {
            this.artCourseDetailFunc();
          })
          .catch((err) => {
            console.log(err);
          });
    },
    setTime(time, flag = false) {
      let m = parseInt((time / 60) % 60);
      m = m < 10 ? "0" + m : m;
      let s = parseInt(time % 60);
      s = s < 10 ? "0" + s : s;
      let str = `${m}:${s}`;
      if (flag) {
        str = `${m}分${s}秒`;
      }
      return str;
    },
    handleShare(type) {
      switch (type) {
        case 'link':
          console.log("分享" + type);
          break;
        case 'wechat':
          console.log("分享" + type);
          break;
        case 'other':
          console.log("分享" + type);
          break;
        default:
          console.log("未知分享")
      }
    },
    artCourseDetailFunc() {
      artCourseDetail(this.id, {
        uid: this.userInfo.uid | 0,
      })
          .then((res) => {
            console.log("detail", res);
            this.detail = res.data;
            this.config.title=res.data.title;
            this.config.image=res.data.imageUrl;
            this.config.description=res.data.content;
            this.activeKeys = res.data.courseChapterVos != null ? this.detail.courseChapterVos.map((_, i) => i) : [];
          })
          .catch((err) => {
            console.log(err);
          });
      getInstructions().then(res => {
        this.instructionsData = res.data;
      })
      getReplyList({courseId: this.id, uid: this.userInfo.uid | 0}).then(res => {
        this.msgReplyData = res.data
      })
    },
    handleBuy(item) {
      if (this.isLogin) {
        if (item.discountPrice > 0) {
          if (item.isBuy == 0) {
            console.log("开始购买")
            this.$router.push({
              name: "OrderDetail",
              params: {
                courseId: item.id,
              },
            })
          } else {
            this.$success({
              title: "提示",
              content: '已购买 不需要重复购买',
            });
            return false;
          }
        }
      } else {
        this.$router.push({path: '/login'})
      }
    },
    handleStartPlayer(detail) {
      let item = detail.courseChapterVos[0].courseChapterVideoVos[0];
      this.handleVideoPlayer(item);
    },
    handleVideoPlayer(item) {
      console.log(item)

      this.$store.state.courseData = this.detail;
      getPlayAuth(item.id)
          .then((res) => {
            console.log("getPlayAuth")
            console.log(res)
            if (res.status == 200) {
              this.cid = item.id;
              this.options.playauth = res.data.playAuth;
              this.options.vid = res.data.videoMeta.videoId;
              this.options.cover = res.data.videoMeta.cover;
              this.isShow = true
              this.setHeight();
            }else if(res.status==5101){
              this.$message.warn(res.msg)
            }else {
              this.$message.error(res.msg)
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
  },
};
</script>

<style lang="scss">

.course-detail-wrapper {
  .course-detail {
    box-sizing: border-box;
    border-top: 1px solid #f2f2f2;
    padding: 0px 0 10px;
    height: auto;

    .detail-nav {
      margin: 10px auto;
      width: 1280px;
      font-size: 14px;
      color: #999999;
      display: flex;
    }

    .detail-top {
      margin: 0 auto;
      width: 1280px;
      display: flex;
      justify-content: space-between;

      .goods-img {
        border-radius: 6px;
        width: 960px;
        height: 540px;
      }

      .aliplayer {
        //margin-bottom: 52px;
      }

      .detail-list {
        border: 1px solid #f2f2f2;
        border-radius: 6px;
        width: 301px;
        height: 540px;


        .detail-list-top {
          padding: 5px 10px;
          margin: 5px auto;
          position: absolute;
          display: flex;
          border-bottom: 1px solid #f2f2f2;
          justify-content: space-between;
          text-align: center;
          span {
            width: 80px;
            margin: 5px 0;
          }

          .title-btn1 {
            width: 80px;
            margin-left: 20px;
            em {
              height: 25px;
              padding-right: 28px;
              background: url("~@/assets/img/star-2.png") no-repeat right 1px;
              background-size: 20px 20px;
              color: #aaa;
              cursor: pointer;
            }

            em.collection {
              background-image: url("~@/assets/img/star.png");
              color: #f59a23;
            }
          }

          .title-btn2 {
            width: 80px;
            margin-left: 20px;
            position: relative;
            display: inline-block;

            em {
              margin-top: 10px;
              padding-right: 18px;
              background: url("~@/assets/img/fenxiang.png") no-repeat right 0px top 4px;
              background-size: 14px 14px;
              color: #aaa;
              cursor: pointer;
            }

            .share-popup {
              position: absolute;
              top: 100%;

              background: #fff;
              border: 1px solid #ddd;
              border-radius: 4px;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
              padding: 8px;
              display: flex;
              gap: 8px;
              z-index: 1000;
            }
          }
        }
        .detail-list-content{
          margin-top: 50px;
          height: 490px;
          overflow-y: auto;
        }
        .ant-collapse {
          margin-bottom: 65px;
          background: #fff;
        }

        .ant-collapse > .ant-collapse-item {
          border: none;
        }

        .ant-collapse > .ant-collapse-item > .ant-collapse-header {
          height: 46px;
          padding: 11px 0 17px 33px;
          border-bottom: 1px solid #f2f2f2;
          line-height: 17px;
          font-size: 15px;
          color: #333;
        }

        .ant-collapse-arrow {
          left: 0 !important;
          color: #2c3f52;
          margin-top: -3px;
          margin-left: 10px;

          svg {
            font-size: 17px;
            color: #E28947;
          }
        }

        .ant-collapse-content-box {
          padding: 0 !important;

          .course-item {
            height: 67px;
            padding-left: 27px;
            border-bottom: 1px solid #f2f2f2;
            position: relative;
            cursor: default;

            &:hover h5, &:hover img,
            &:hover p {
              color: #333 !important;
            }

            h5 {
              margin: 0;
              padding: 13px 0 15px;
              height: 41px;
              line-height: 13px;
              font-size: 13px;
              color: #7f7f7f;
            }

            p {
              margin: 0;
              font-size: 12px;
              line-height: 12px;
              color: #7f7f7f;
            }

            img {
              width: 22px;
              height: 22px;
              position: absolute;
              top: 23px;
              right: 10px;
            }
          }
        }
      }
    }

    .detail-info {
      margin: 0 auto;
      width: 1280px;

      .detail-list {
        width: 960px;
        display: flex;
        justify-content: space-between;

        .detail {
          width: 860px;

          .category-info {
            margin: 20px 0 10px 0;
            line-height: 32px;
            font-size: 14px;
          }

          .title {
            line-height: 32px;
            font-size: 24px;
            padding-bottom: 10px;
            font-weight: 700;
            color: #333;
            margin: 0;
          }

          .price {
            line-height: 35px;

            .free {
              color: #7bA5A4;
              font-weight: 700;
              font-size: 24px;
            }

            span:nth-of-type(1) {
              font-size: 14px;
              color: #aaa;

              em {
                font-size: 24px;
                color: #d9001d;
                margin: 0 0 0 14px;
              }

              strong {
                font-size: 24px;
                color: #d9001d;
              }
            }

            span:nth-of-type(2) {
              margin: 0 28px 0 24px;
              font-size: 14px;
              color: #aaa;

              strong {
                margin-left: 8px;
              }
            }

            span:nth-of-type(3) {
              font-size: 14px;
              color: #aaa;

              strong {
                margin-left: 8px;
              }
            }
          }

          .lecturer {
            line-height: 29px;
            font-size: 14px;
            color: #aaa;

            strong {
              color: #333;
              margin: 0 38px 0 10px;
            }

            em {
              padding-right: 18px;
              background: url("~@/assets/img/star-2.png") no-repeat right 2px;
              background-size: 14px 14px;
              color: #aaa;
              cursor: pointer;
            }

            em.collection {
              background-image: url("~@/assets/img/star.svg");
              color: #f59a23;
            }
          }
        }

        .btn {
          margin: 75px auto 0;
          width: 100px;
          border-radius: 30px;
          height: 36px;
          line-height: 36px;
          background-color: #DF7645;
          color: #fff;
          text-align: center;
          font-size: 14px;
        }
      }

    }
  }

  .course-introduction {
    margin: 0 auto;
    width: 1280px;

    h3.title {
      margin: 0;
      line-height: 36px;
      font-size: 24px;
      font-weight: 800;
      color: #333;
    }

    .course-teacher-info {
      margin-top: 14px;
      display: flex;
      justify-content: space-between;
      border-radius: 10px;
      border: 1px solid #DDDDDD;

      .course-teacher-title {
        width: 220px;
        border-radius: 10px 0 0 10px;
        background: #dddddd;

        .name {
          display: flex;
          align-items: center; /* 垂直居中 */
          justify-content: center; /* 水平居中 */
          padding: 10px 20px 10px 20px;
          width: 110px;
        }

        .content {

          display: flex;
          align-items: center; /* 垂直居中 */
          justify-content: center; /* 水平居中 */
          padding: 25px 20px 25px 20px;
        }
      }

      .course-teacher-content {

        .teacher {
          padding: 10px 10px 10px 5px;
          min-height: 35px;
          border-bottom: 1px solid #DDDDDD;
        }

        .content {
          color: #7f7f7f;
          line-height: 1.2;
          letter-spacing: 0.05em;
          text-indent: 2em;
          padding: 10px 10px 10px 5px;
        }
      }
    }


    .desc {
      padding: 22px 0 8px;
      line-height: 15px;
      font-size: 15px;
      color: #aaa;

      span {
        margin: 0 39px 0 10px;
      }

      em {
        margin: 0 16px 0 10px;
      }
    }

    .course-image{
      margin: 20px auto;
      width: 640px;
      color: #666666;
      font-size: 16px;
      img{
        width: 100%;
      }
    }
  }

  .course-need {
    margin: 20px auto;
    width: 1280px;
    color: #666666;
    font-size: 16px;

    .title {
      display: block; /* 将 span 元素转换为块级元素，使其可以应用 margin */
      margin: 5px 0;
    }

    .list-title {
      margin: 15px 0;
      font-size: 14px;

      span {
        width: 50px;
        height: 30px;
        color: #ffffff;
        padding: 3px 10px 8px 18px;
        background: url("~@/assets/img/course-need.png") no-repeat;
        background-size: 36px 25px;
      }
    }

    .list-content {
      margin: 22px 0;
      font-size: 12px;
      color: #999999;
    }

    .list-line {
      border-top: 1px solid #e3e1e1;
    }
  }

  .course-msg {
    margin: 20px auto;
    width: 1280px;
    color: #666666;

    .msg-video-reply {
      > div:first-child {
        /* 用户评价标题样式，可根据需要调整 */
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
      }

      .video-item {
        .video-bbs {
          margin: 10px 0;
          border: 1px solid #e3e1e1;
          border-radius: 10px;
          padding: 20px 0 14px 11px;

          .userAvatar {
            margin-bottom: 10px;
            height: 35px;
            line-height:35px;
            display: flex;
            justify-content: space-around;
            width: 240px;
            img {
              width: 34px;
              height: 34px;
              border-radius: 50%;
            }

            .img-sub {
              width: 34px;
              height: 34px;
              line-height: 35px;
              border-radius: 50%;
            }

            span {
              display: inline-block;
              line-height: 34px;
              font-size: 17px;
              color: #7f7f7f;
              vertical-align: middle;
              margin: 0 40px 0 21px;
            }

            em {
              padding-right: 18px;
              margin-top: 6px;
              background: url("~@/assets/img/star3-2.png") no-repeat right 2px;
              background-size: 18px 18px;
              line-height: 35px;
              color: #aaa;
              cursor: pointer;
              outline: none; // 移除聚焦时的蓝色轮廓
            }

            em.collection {
              margin-top: 6px;
              background-image: url("~@/assets/img/star3-1.png");
              color: #f59a23;
              line-height: 35px;
              outline: none; // 移除聚焦时的蓝色轮廓
            }
          }

          .desc {
            margin: 0 0 10px 53px;
            line-height: 29px;
            font-size: 15px;
            color: #aaa;
            word-break: break-all;
          }

          .footer {
            padding: 5px 0 0 53px;
            font-size: 15px;
            line-height: 23px;
            color: #aaa;

            img {
              vertical-align: text-bottom;
            }

            .good {
              width: 19px;
              height: 19px;
              margin: 0 7px 0 23px;
              filter: invert(1);
            }

            span {
              display: inline-block;
              margin: 0 15px 0 11px;
              line-height: 23px;
            }

            .good-wrap {
              float: left;
              font-size: 15px;
              line-height: 23px;

              span {
                margin-left: 20px;
              }

              &.sub {
                float: left;
                margin-left: -23px;
              }
            }
          }
        }
      }
    }
  }
}

</style>
